import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { UserProvider } from './auth/context/user-context';
import { Menu } from '../components/Menu/Menu';
import { WorkspaceLayout } from '../components/WorkspaceLayout';
import { PaymentOperatorAlerts } from './payments/PaymentOperatorAlerts';

/** Select the route's workspace shell while retaining navigation and payment alerts. */
function MainApp() {
  const { pathname } = useLocation();
  if (
    pathname === '/credentialing' ||
    pathname.startsWith('/credentialing/') ||
    pathname === '/aloha-provisioning' ||
    pathname.startsWith('/aloha-provisioning/')
  ) {
    return (
      <WorkspaceLayout navigation={<Menu />}>
        <PaymentOperatorAlerts />
        <Outlet />
      </WorkspaceLayout>
    );
  }
  return (
    <div className="flex-1 flex bg-secondary">
      <>
        <Menu />
        <div className={`flex-1 max-h-screen overflow-auto p-2 md:p-4 lg:p-8 !pt-[105px] lg:!pt-8`}>
          <PaymentOperatorAlerts />
          <Outlet />
        </div>
      </>
    </div>
  );
}

export function Main() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if (!token || !userData?.id) {
      navigate('/login');
      setIsLoggedIn(false);
    } else {
      setIsLoggedIn(true);
      if (location.pathname === '/') {
        navigate('/dashboard');
      }
    }
  }, [location]);

  if (!isLoggedIn) return null;

  return (
    <UserProvider>
      <MainApp />
    </UserProvider>
  );
}
